export default "__VITE_ASSET__DdPMtKCY__"